import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var getImageInfo = normalize.getImageInfo(function (args) {
  return tt.getImageInfo(args);
}, CONTAINER_NAME.BYTE);
export default getImageInfo;